import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import examActions from "../../Redux/exam/actions";
import Cookies from "js-cookie";
import { useForm } from "react-hook-form";
import authActions from "../../Redux/auth/actions";
import { InputTrimFunction } from "../../utils/validations";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { handleEncodeJson } from "../../utils/encodeDecodeJson";
import loginLogo from "../../assets/images/logo.png";
import PrimaryButton from "../../common/primaryButton";
import loginBg from "../../assets/images/login_background.png";
import PersonIcon from "@mui/icons-material/Person";
import LockPersonIcon from '@mui/icons-material/LockPerson';
import passlock from "../../assets/images/passicon.svg"
import usericon from "../../assets/images/usericon.svg"
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

export default function Index() {
  // State declaractions
  const [passState, setPassState] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { projectDetails, heartBeat } = useSelector(
    (state) => state.examReducer
  );
  const { buttonLoader } = useSelector((state) => state.commonReducer);
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm();

  // Derieved variables
  const url = searchParams.get("apiUrl");
  const isVenue = sessionStorage.getItem("isVenue");

  const textStyle = {
    fontSize: "14px",
    color: "#484848",
    fontWeight: "500",
    mb: 1,
  };

  // Side effects
  useEffect(() => {
    dispatch({
      type: examActions.GET_PROJECT_DETAILS,
      payload: {
        data: {
          project: Cookies.get("test_engine_project")
            ? Cookies.get("test_engine_project")
            : "undefined",
        },
        navigate: navigate,
        url: url,
      },
    });
  }, []);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  // Helper functins

  const handleLogin = async (data) => {
  localStorage.setItem('userName',data?.username); 
  localStorage.setItem('password',data?.password); 
    const formData = {
      ...data,
      projectShortName: projectDetails?.projectShortName,
    };
    const encodedData = await handleEncodeJson({ encodeJSON: formData });
    dispatch({
      type: authActions.CANDIDATE_LOGIN,
      payload: {
        data: encodedData,
        navigate: navigate,
        setError: setError,
        mockMode: projectDetails?.mockMode ? projectDetails?.mockMode : false,
        url: url,
      },
    });

  };

  useEffect(() => {
    if (projectDetails?.logo) {
      const favicon = document.getElementById("dynamic-favicon");
      if (favicon) {
        favicon.href = projectDetails.logo;
      }
    }
  }, [projectDetails?.logo]);

  return (
    <>
      {/* <Grid
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          pr: 20,
       
        }}
      > */}
      {/* <Box
          sx={{
            background: "#fff",
            height: "35px",
            width: isOnline ? "130px" : "150px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            filter: "drop-shadow(0 4px 4px rgba(0, 0, 0, 0.12))",
          }}
        >
          {" "}
          <Typography
            sx={{
              color: isVenue
                ? heartBeat?.code === "OK"
                  ? "rgba(84, 179, 55, 1)"
                  : "rgba(234, 104, 58, 1)"
                : isOnline
                ? "rgba(84, 179, 55, 1)"
                : "rgba(234, 104, 58, 1)",
              display: "flex",
              alignItems: "center",
              fontWeight: 500,
            }}
          >
            <span style={{ fontSize: "50px", fontWeight: "bold" }}>•</span>
            &nbsp;{isOnline ? "Connected" : "Disconnected"}
          </Typography>
        </Box> */}
      {/* </Grid> */}
      <Grid
        component={"form"}
        onSubmit={handleSubmit(handleLogin)}
        sx={{
         minHeight: {xs: "100dvh", // ✅ small screens me dynamic height use karo
      sm: "100vh",
      md: "100vh" },
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
             backgroundImage: `url(${loginBg})`, // 👈 image ka path
              backgroundSize: {
      xs: "cover",   // small screen (mobile)
      sm: "cover",   // small screen
      md: "1050px",  // medium and above
      lg: "1050px",
    },
    backgroundPosition: {
      xs: "center",  // for mobile
      sm: "center",
       md: "unset",
    },
    // backgroundSize: "cover",   // 👈 poora cover kare
    backgroundRepeat: "no-repeat",
    // backgroundPosition: "center",
        }}
      >
        <Grid
          container
          spacing={1}
          sx={{
            position:"absolute",
            height: "450px",
            width: { xs: "300px", sm: "390px" },
            background: "#fff",
            borderRadius: "15px",
            padding: "30px",
            display: "flex",
            justifyContent: "center",
            border: "1px solid #00000029",
            boxShadow: "rgba(0, 0, 0, 0.12)",
            margin: "10px",
            left: {
      xs: "unset", // sm aur niche left hata do
      sm: "unset",
      md: "55%", // md se apply hoga
    },
    
    alignItems: {
      xs: "center", // sm aur niche center
      sm: "center",
      md: "unset",
    },
          }}
        >
          <Box
            component={"img"}
            src={ projectDetails?.logo ? projectDetails?.logo : loginLogo}
            alt="logo"
            sx={{ height: "70px", width: "auto" }}
          />
          <Grid item md={12} xs={12}> <Typography sx={{fontSize:"20px",fontWeight:"600"}}>Login</Typography></Grid>
          <Grid item md={12} xs={12} mt={-2}>
           
            <FormControl fullWidth>
              <Typography sx={textStyle}>User ID </Typography>
              <TextField
                size="small"
                fullWidth
                placeholder="Enter User ID"
                id="username"
                type="text"
                variant="outlined"
                error={!!errors.username}
                {...register("username", {
                  required: "User ID is required",
                })}
                helperText={errors.username?.message}
                FormHelperTextProps={{
                  style: { margin: 0,fontWeight:"12px" },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment
                      position="start"
                      sx={{
                        margin: 0// 👈 removes default MUI gap
                      }}
                    >
                      <Box
                        sx={{
                          backgroundColor: "#2B5BAB", // Blue background
                          width: 40,                       // fixed width
                          height: "38px",                  // 👈 match TextField height (small ~38px)
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderTopLeftRadius: "4px",      // match field border radius
                          borderBottomLeftRadius: "4px",


                        }}
                      >
                        <img src={usericon} alt="usericon" height="18px" width="18px" sx={{ color: "#fff", fontSize: 20 }} /> {/* White icon */}
                      </Box>
                    </InputAdornment>
                  ),
                  sx: {
                    "&.MuiOutlinedInput-root": {
                      paddingLeft: "0 !important"
                    },
                  },
                  inputProps: {
                    style: {
                      fontSize: "15px",
                      paddingLeft: "5px"
                    },
                  },
                }}
              />
            </FormControl>
          </Grid>
          <Grid item md={12} xs={12} mt={-1}>
            <FormControl fullWidth>
              <Typography sx={textStyle}>Password*</Typography>
              <TextField
                size="small"
                fullWidth
                id="password"
                placeholder="Enter Password"
                type={passState ? "text" : "password"}
                InputProps={{
                  startAdornment: (
      <InputAdornment
        position="start"
        sx={{
          margin: 0// 👈 removes default MUI gap
        }}
      >
        <Box
          sx={{
            backgroundColor: "#2B5BAB", // Blue background
            width: 40,                       // fixed width
            height: "38px",                  // 👈 match TextField height (small ~38px)
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderTopLeftRadius: "4px",      // match field border radius
            borderBottomLeftRadius: "4px",
            
           
          }}
        >
          <img src={passlock} alt="passlock" height="18px" width="18px" sx={{ color: "#fff", fontSize: 15 }} /> {/* White icon */}
        </Box>
      </InputAdornment>
    ),
    sx: {
      "&.MuiOutlinedInput-root": {
        paddingLeft: "0 !important", 
      },
      
    },
    inputProps: {
      style: {
        fontSize: "15px",
        paddingLeft:"5px"
      },
    },
  
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setPassState(!passState)}
                        sx={{ paddingRight: "0" }}
                      >
                        {passState ? (
                          <FiEye size={18} />
                        ) : (
                          <FiEyeOff size={18} />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                error={!!errors.password}
                {...register("password", {
                  required: "Password is required",
                })}
                onInput={InputTrimFunction}
                helperText={errors.password?.message}
                FormHelperTextProps={{
                  style: { margin: 0 },
                }}
              />
            </FormControl>
          </Grid>
          <Grid item md={12} xs={12} sx={{
            width: "100%", display: "flex",
            justifyContent: "center"
          }}>
            <Button
              size='small'
              variant='contained'

              sx={{

                fontSize: '14px',
                padding: '4px',
                backgroundColor: '#2D5EAB',
                height: "35px",
                width: "120px",
                color: "#ffffff",
                fontSize: "12px"
              }}
              type="submit"
            >

              {buttonLoader ? "Logging in" : "Login"}{" "}<ArrowForwardIcon sx={{ color: "white", fontSize: '18px' }} />
            </Button>

          </Grid>
          {/* <Grid item md={12} xs={12} sx={{width:"100%",display:"flex",
                  justifyContent:"center"}}>
              <Typography style={{color: '#2D5EAB',fontSize:"12px",fontWeight:"bold"}}>Forgot Password</Typography>
             </Grid> */}
        </Grid>
        {/* <Typography
          variant="caption"
          sx={{ color: "rgba(30, 30, 30, 0.4)", size: "8px", padding: "4px" }}
        >
          IP : 192.168.0.1&nbsp;&nbsp;&nbsp;Mac Address :
          1233.F442.3444.5564&nbsp;&nbsp;&nbsp;PC Name: My computer
        </Typography> */}
      </Grid>
    </>
  );
}
